package oldcomponents.page

import kotlinx.css.*
import react.PropsWithChildren
import react.dom.div
import react.fc
import styled.css
import styled.styledDiv

external interface BasePageContentProps : PropsWithChildren {
    var active: Boolean
}

external interface PageContentProps : BasePageContentProps {
    var headerProps: PageHeaderProps
    var loading: Boolean
}

//external interface UserPageContentProps : PageContentProps {
//    var user: CurrentUser
//}

val pageContent = fc<PageContentProps> { props ->
    styledDiv {
        css {
            classes.add("content-inner")
            if (props.active) {
                classes.add("active")
            }
            position = Position.relative
        }
        div("container-fluid") {
            if (props.loading) {
                styledDiv {
                    css {
                        background = "rgba(46, 52, 81, 0.8)"
                        display = Display.block
                        position = Position.absolute
                        left = 0.px
                        top = 0.px
                        width = 100.pct
                        height = 100.pct
                        zIndex = 999
                    }
                    div("canvas") {
                        div("spinner") {}
                    }
                }
            }
            if (undefined != props.headerProps) {
                pageHeader(props.headerProps)
            }
            props.children()
        }
    }
}
